export const DEV_FEATURE_OVERRIDES_STORAGE_KEY = 'iqx-dev-feature-overrides';

export type DevFeatureOverrides = {
  added: string[];
  removed: string[];
};

export const devFeatureOverrides: DevFeatureOverrides = (() => {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(DEV_FEATURE_OVERRIDES_STORAGE_KEY) ?? '{}',
    );
    return {
      added: Array.isArray(parsed.added)
        ? parsed.added.filter((x: unknown) => typeof x === 'string')
        : [],
      removed: Array.isArray(parsed.removed)
        ? parsed.removed.filter((x: unknown) => typeof x === 'string')
        : [],
    };
  } catch {
    return { added: [], removed: [] };
  }
})();

export const hasActiveDevFeatureOverrides =
  devFeatureOverrides.added.length > 0 ||
  devFeatureOverrides.removed.length > 0;
